<pk-web-loader [show]="loading"></pk-web-loader>
@if (!loading && (showYearsInBusiness || (webSuccessMetrics && (showSatisfiedCustomers || showAssetsUnderManagement)))) {
	<div class="row width-limit-1320 d-flex align-items-center justify-content-center">
		@if (showSatisfiedCustomers && webSuccessMetrics) {
			<div class="col-12 col-sm-8 col-md-6 col-lg-4 py-4">
				<div class="card company-stat-card">
					<div class="card-body">
						<div class="row d-flex justify-content-center">
							<div class="col-auto company-stat">
								<p class="smaller-text">
									<img src="https://assets.powerkiosk.com/web/images/thumbs-up-orange-icon.svg" alt="Thumb up" class="icon-img" /> Satisfied Customers
								</p>
								<p id="satisfiedCust" class="big-number">{{ webSuccessMetrics.totalSatisfiedCustomers | shortNumber }} +</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		}
		@if (showSatisfiedCustomers && webSuccessMetrics && (showAssetsUnderManagement || showYearsInBusiness)) {
			<div class="w-100 d-block d-lg-none"></div>
		}
		@if (showAssetsUnderManagement && webSuccessMetrics) {
			<div class="col-12 col-sm-8 col-md-6 col-lg-4 py-4">
				<div class="card company-stat-card">
					<div class="card-body">
						<div class="row d-flex justify-content-center">
							<div class="col-auto company-stat">
								<p class="smaller-text">
									<img src="https://assets.powerkiosk.com/web/images/dollar-bill-blue-icon.svg" alt="Dollar Bill" class="icon-img" />
									Energy Spend Under Management
								</p>
								<p id="assetsUnderMgt" class="big-number">{{ webSuccessMetrics.totalKwhs + webSuccessMetrics.totalTherms | shortNumber: true }} +</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		}
		@if (showAssetsUnderManagement && webSuccessMetrics && showYearsInBusiness) {
			<div class="w-100 d-block d-lg-none"></div>
		}
		@if (showYearsInBusiness) {
			<div class="col-12 col-sm-8 col-md-6 col-lg-4 py-4">
				<div class="card company-stat-card">
					<div class="card-body">
						<div class="row d-flex justify-content-center">
							<div class="col-auto company-stat">
								<p class="smaller-text">
									<img src="https://assets.powerkiosk.com/web/images/calendar-green-icon.svg" alt="Calendar" class="icon-img" /> Years in Business
								</p>
								<p id="yrsInBusiness" class="big-number">{{ yearsInBusiness }} years</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		}
	</div>
}
